import { type AriaAttributes, type ReactNode } from 'react'
import styles from './SelectionLabel.module.css'
import cx from 'classnames'
import { AutoSkeleton } from '@/components/Skeleton'

interface SelectionLabelProps extends AriaAttributes {
  children?: ReactNode
  for?: string
  id?: string

  /**
   * Whether the field is invalid.
   */
  invalid?: boolean
}

/**
 * Label intended for use with checkboxes and radio boxes.
 */
export function SelectionLabel({
  children,
  for: htmlFor,
  id,
  invalid,
  ...rest
}: SelectionLabelProps) {
  return (
    <label
      htmlFor={htmlFor}
      id={id}
      {...rest}
      className={cx(styles.root, invalid && styles.labelInvalid)}
    >
      {children}
    </label>
  )
}

interface SelectionLabelControlProps {
  children?: ReactNode
}

/**
 * Selection Label Control
 */
export function SelectionLabelControl({
  children,
}: SelectionLabelControlProps) {
  return <div className={styles.control}>{children}</div>
}

interface SelectionLabelTextProps {
  children?: ReactNode

  /**
   * Whether to render a skeleton instead of the text.
   */
  isSkeleton?: boolean
}

/**
 * Selection Label Text
 */
export function SelectionLabelText({
  children,
  isSkeleton,
}: SelectionLabelTextProps) {
  return (
    <div className={styles.text}>
      <AutoSkeleton disableCorrections isSkeleton={isSkeleton}>
        {children}
      </AutoSkeleton>
    </div>
  )
}
